import EventEmitter from 'events';
import { serializeDataset, deserializeDataset } from '@gephi/gephi-lite-sdk';
import { isPlainObject } from 'lodash';
import { v4 } from 'uuid';

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

/**
 * Helper types:
 * *************
 * (This helper type has been kindly taken from @Yomguithereal code in sigma)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

var TypedEventEmitter = /*#__PURE__*/function (_ref) {
  function TypedEventEmitter() {
    var _this;
    _classCallCheck(this, TypedEventEmitter);
    _this = _callSuper(this, TypedEventEmitter);
    _this.rawEmitter = _this;
    return _this;
  }
  _inherits(TypedEventEmitter, _ref);
  return _createClass(TypedEventEmitter);
}(EventEmitter);

/**
 * Base types:
 * ***********
 */

/**
 * Messages:
 * *********
 */

/**
 * List all methods:
 * *****************
 *
 * 1. Data update/reading:
 *   - [x] getGraph(): SerializedFullGraph / importGraph(graph: FullGraph)
 *   - [x] setGraphDataset / getGraphDataset / mergeGraphDataset
 *   - [x] setGraphAppearance / getGraphAppearance / mergeGraphAppearance
 *   - [x] setFilters / getFilters
 *   - [ ] setSelection / getSelection
 *
 * 2. Other methods:
 *   - [x] ping (to check broadcast status)
 *   - [x] getVersion
 *   - [ ] zoomToNodes / resetZoom
 *   - [ ] computeMetric
 *   - [ ] computeLayout / startLayout / stopLayout
 *   - [ ] notify
 *   - [ ] exportGraph
 *   - [ ] methods to handle UI elements (right panel, left tabs, caption,
 *         fullscreen)
 *
 * 3. Events
 *   - [x] instanceCreation
 *   - [ ] graphUpdate
 *   - [ ] graphModelUpdate
 *   - [ ] graphAppearanceUpdate
 *   - [ ] filtersUpdate
 *   - [ ] selectionUpdate
 */

/**
 * Method types:
 * *************
 */

/**
 * Event types:
 * ************
 */

function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}

function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

/**
 * This class aims at helping to control Gephi Lite from another web
 * application.
 */
var GephiLiteDriver = /*#__PURE__*/function (_TypedEventEmitter) {
  function GephiLiteDriver() {
    var _this;
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : v4();
    _classCallCheck(this, GephiLiteDriver);
    _this = _callSuper(this, GephiLiteDriver);
    _defineProperty(_this, "timeout", 2000);
    _defineProperty(_this, "pendingReplies", new Map());
    _defineProperty(_this, "window", null);
    _this.name = name;
    _this.channel = new BroadcastChannel(name);
    _this.channel.onmessage = _this.handleMessage.bind(_this);
    return _this;
  }
  _inherits(GephiLiteDriver, _TypedEventEmitter);
  return _createClass(GephiLiteDriver, [{
    key: "handleMessage",
    value: function handleMessage(_ref) {
      var messageData = _ref.data;
      var pendingReplies = this.pendingReplies;
      if (!isPlainObject(messageData) || typeof messageData.type !== "string") return;
      var _ref2 = messageData,
        type = _ref2.type,
        payload = _ref2.payload;
      switch (type) {
        case "replyMessage":
          {
            var _ref3 = messageData,
              replyTo = _ref3.replyTo;
            var pending = pendingReplies.get(replyTo);
            if (pending) {
              pending(payload);
              pendingReplies["delete"](replyTo);
            }
            break;
          }
        case "broadcastMessage":
          {
            if (isPlainObject(payload) && payload.type === "event") {
              var _payload = messageData.payload,
                event = _payload.event,
                data = _payload.data;
              this.emit(event, data);
            }
          }
      }
    }
  }, {
    key: "callMethod",
    value: function callMethod(method) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var timeout = this.timeout,
        pendingReplies = this.pendingReplies,
        channel = this.channel;
      var messageID = v4();
      return new Promise(function (resolve, reject) {
        pendingReplies.set(messageID, function (payload) {
          return resolve(payload);
        });
        var message = {
          id: messageID,
          type: "broadcastMessage",
          payload: {
            type: "callMethod",
            method: method,
            args: args
          }
        };
        channel.postMessage(message);
        if (timeout > 0) {
          window.setTimeout(function () {
            var pending = pendingReplies.get(messageID);
            if (pending) {
              reject(new Error("Call to method ".concat(method, " (message ID: ").concat(messageID, ") timed out after ").concat(timeout, "ms.")));
            }
          }, timeout);
        }
      });
    }

    /**
     * Methods shortcuts:
     * ******************
     */
  }, {
    key: "ping",
    value: function ping() {
      return this.callMethod("ping");
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return this.callMethod("getVersion");
    }
  }, {
    key: "importGraph",
    value: function importGraph(graph) {
      return this.callMethod("importGraph", graph);
    }
  }, {
    key: "getGraph",
    value: function getGraph() {
      return this.callMethod("getGraph");
    }
  }, {
    key: "getGraphDataset",
    value: function () {
      var _getGraphDataset = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var dataset;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.callMethod("getGraphDataset");
            case 1:
              dataset = _context.v;
              return _context.a(2, deserializeDataset(dataset));
          }
        }, _callee, this);
      }));
      function getGraphDataset() {
        return _getGraphDataset.apply(this, arguments);
      }
      return getGraphDataset;
    }()
  }, {
    key: "setGraphDataset",
    value: function setGraphDataset(dataset) {
      return this.callMethod("setGraphDataset", serializeDataset(dataset));
    }
  }, {
    key: "mergeGraphDataset",
    value: function mergeGraphDataset(dataset) {
      return this.callMethod("mergeGraphDataset", serializeDataset(dataset));
    }
  }, {
    key: "getAppearance",
    value: function getAppearance() {
      return this.callMethod("getAppearance");
    }
  }, {
    key: "setAppearance",
    value: function setAppearance(appearance) {
      return this.callMethod("setAppearance", appearance);
    }
  }, {
    key: "mergeAppearance",
    value: function mergeAppearance(appearance) {
      return this.callMethod("mergeAppearance", appearance);
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.callMethod("getFilters");
    }
  }, {
    key: "setFilters",
    value: function setFilters(filters) {
      return this.callMethod("setFilters", filters);
    }
  }, {
    key: "getWindow",
    value: function getWindow() {
      return this.window;
    }

    /**
     * Helper/lifecycle methods:
     * *************************
     */
  }, {
    key: "openGephiLite",
    value: (function () {
      var _openGephiLite = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var _ref4,
          _ref4$baseUrl,
          baseUrl,
          _ref4$target,
          target,
          _ref4$features,
          features,
          _ref4$timeout,
          timeout,
          url,
          gephiLiteWindow,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref4$baseUrl = _ref4.baseUrl, baseUrl = _ref4$baseUrl === void 0 ? "/gephi-lite" : _ref4$baseUrl, _ref4$target = _ref4.target, target = _ref4$target === void 0 ? "_blank" : _ref4$target, _ref4$features = _ref4.features, features = _ref4$features === void 0 ? "noopener" : _ref4$features, _ref4$timeout = _ref4.timeout, timeout = _ref4$timeout === void 0 ? 10000 : _ref4$timeout;
              url = undefined;
              try {
                url = new URL(baseUrl);
              } catch (_unused) {
                // not an url, assuming a path, nothing to check
              }
              if (!url) {
                _context2.n = 1;
                break;
              }
              if (!(url.host !== window.location.host)) {
                _context2.n = 1;
                break;
              }
              throw new Error("Communicating with Gephi Lite is only possible on the same domain.");
            case 1:
              _context2.n = 2;
              return new Promise(function (resolve, reject) {
                var openingGephiLiteTimeout = timeout ? setTimeout(function () {
                  reject(new Error("Couldn't set up communication channel with Gephi Lite before ".concat(timeout)));
                }, timeout) : null;

                // Wait for new instance to be fully working:
                _this2.on("newInstance", function () {
                  if (openingGephiLiteTimeout) clearTimeout(openingGephiLiteTimeout);
                  resolve(_this2.getWindow());
                });
                _this2.window = open("".concat(baseUrl, "?broadcast=").concat(_this2.name), target, features);
              });
            case 2:
              gephiLiteWindow = _context2.v;
              return _context2.a(2, gephiLiteWindow);
          }
        }, _callee2);
      }));
      function openGephiLite() {
        return _openGephiLite.apply(this, arguments);
      }
      return openGephiLite;
    }())
  }, {
    key: "destroy",
    value: function destroy() {
      this.channel.onmessage = null;
      this.channel.close();
      this.channel = null;
      this.pendingReplies = new Map();
    }
  }]);
}(TypedEventEmitter);

export { GephiLiteDriver, TypedEventEmitter };
